// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3wcbk","rootSmall":"AddTileButton_rootSmall__1CrRa"};